import * as React from 'react'
import { imagePlaceholder } from 'src/static/fixtures/imagePlaceholder'
import { convertToBoolean, enablePlpRedesign } from 'src/utils'
import { APPConfig } from 'config/appConfig/AppConfig'
import './styles.scss'

class ImageComponent extends React.Component {
  getSrcSet = () => {
    let srcSet = []
    if (this.props?.srcSet?.length > 0 && this.props?.src) {
      srcSet = this.props?.srcSet?.map(imageSrc => {
        const url = `${this.props.src}?width=${imageSrc} ${imageSrc}w`
        return url
      })
    }
    return srcSet.join(' , ')
  }
  render() {
    const {
      src = '',
      name,
      className = '',
      testId,
      width = 'auto',
      height = 'auto',
      ariaLabel = '',
      loadingType = 'lazy',
      optimizeImage = false,
      title,
      alt,
      dataAltSrc,
      customParentClassName = '',
      overrideParentClass = false,
      plpImprovementClass = false,
      backgroundColor = true,
    } = this.props
    const enableImageFit =
      convertToBoolean(APPConfig?.getAppConfig()?.enableImageFit) || false
    const parentClass = overrideParentClass
      ? customParentClassName
      : `${backgroundColor ? (enablePlpRedesign() ? 'redesign-plp-img-bg' : 'image-wrapper') : 'image-wrapper-no-bg'} col-12 p-0 m-0 ${
          enableImageFit && plpImprovementClass
            ? 'image-wrapper-plp-improvements'
            : ''
        }`
    const trimmedSrc = typeof src === 'string' ? src.trim() : src || ''
    const widthValue = width?.replace(/[A-Z]/gi, '') || ''
    const widthQueryParam = `width=${widthValue}`
    const concatenateSymbol = trimmedSrc.includes('?') ? '&' : '?'
    const imageQuery = optimizeImage
      ? `${concatenateSymbol}${widthQueryParam}`
      : ''

    const ImageUrl = trimmedSrc ? trimmedSrc + imageQuery : ''

    return (
      <div
        className={parentClass}
        style={{
          width: `${width}`,
          height: `${height}`,
        }}>
        <img
          data-testid={testId}
          onError={e => {
            if (e.target.src != imagePlaceholder) {
              e.target.onerror = null
              e.target.src = imagePlaceholder
            }
          }}
          src={ImageUrl || imagePlaceholder}
          data-src={ImageUrl || imagePlaceholder}
          srcSet={this.getSrcSet()}
          loading={loadingType}
          alt={alt || name}
          height={height}
          width={width}
          title={title}
          className={className}
          aria-label={ariaLabel}
          data-alt-text-resolution={dataAltSrc}
        />
      </div>
    )
  }
}

export { ImageComponent }
export default ImageComponent
